interface GoalProgressChartProps {
  progress: number
}

export default function GoalProgressChart({ progress }: GoalProgressChartProps) {
  const circumference = 2 * Math.PI * 15.9155
  const strokeDashoffset = circumference - (progress / 100) * circumference

  return (
    <div className="relative h-40 w-40 flex-shrink-0 sm:h-48 sm:w-48">
      <svg className="h-full w-full" transform="rotate(-90)" viewBox="0 0 36 36">
        <path
          className="stroke-slate-300"
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          strokeWidth="3.5"
        />
        <path
          className="stroke-indigo-600 transition-all duration-500"
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          strokeWidth="3.5"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-4xl font-bold text-slate-900">{progress}%</span>
        <span className="text-sm text-slate-500">Complete</span>
      </div>
    </div>
  )
}
